import React, { useCallback, useMemo } from 'react';
import PropTypes from 'prop-types';
import Cross from '../../../webcommon/common/Icons/Cross.svg';
import { noop } from 'lodash';
import ActionButton from '../../../webcommon/common/actionbutton/ActionButton';
import defaultStyles from './AddNewRow.module.scss';
import CustomFormComponent from './CustomFormComponent';

const AddNewRow = (props) => {
    const {
        createAction,
        closeModal,
        onlyOneInputOption,
        isEdit
    } = props;
    const createNewMapping = useCallback(() => {
        createAction();
        closeModal();
    }, [createAction, closeModal]);

    const confirmButtonName = useMemo(() => {
        if (onlyOneInputOption) { return 'Add'; }
        if (isEdit) { return 'Edit'; }
        return 'Create';
    }, [onlyOneInputOption, isEdit]);

    return (
        <div className={ props.styles.newMappingWrapper }>
            <div className={ props.styles.newMappingHeader }>
                {props.modalMessage}
                <button
                    type="button"
                    className={ props.styles.mappingHeaderCloseButton }
                    onClick={ props.closeModal }
                >
                    <img
                        alt="Cross"
                        src={ Cross }
                        className={ props.styles.svg }
                    />
                </button>
            </div>

            <div className={ props.styles.formOptions }>
                { props.onlyOneInputOption
                    ? null
                    : (
                        <div className={ props.styles.optionOne }>
                            <CustomFormComponent
                                activeValue={ props.optionOneValue }
                                setActiveValue={ props.setOptionOne }
                                title={ props.optionOneKey }
                                readOnly={ props.firstOptionReadOnly }
                            />
                        </div>
                    )
                }

                <div className={ props.styles.optionTwo }>
                    <CustomFormComponent
                        activeValue={ props.optionTwoValue }
                        dropdownOptions={ props.dropdownOptions }
                        isDropdown={ props.secondOptionDropdown }
                        setActiveValue={ props.setOptionTwo }
                        title={ props.optionTwoKey }
                    />
                </div>
            </div>

            <div className={ props.styles.createMappingButtons }>
                <div className={ props.styles.createNewMappingButton }>
                    <ActionButton
                        accent
                        onClick={ createNewMapping }
                    >
                        { confirmButtonName }
                    </ActionButton>
                </div>
                <div className={ props.styles.cancelMappingButton }>
                    <ActionButton
                        onClick={ props.closeModal }
                    >
                        Close
                    </ActionButton>
                </div>
            </div>
        </div>
    );
};

AddNewRow.propTypes = {
    closeModal: PropTypes.func,
    createAction: PropTypes.func,
    dropdownOptions: PropTypes.arrayOf(PropTypes.string),
    isEdit: PropTypes.bool,
    modalMessage: PropTypes.string,
    optionOneKey: PropTypes.string,
    optionOneValue: PropTypes.string,
    optionTwoKey: PropTypes.string,
    optionTwoValue: PropTypes.string,
    secondOptionDropdown: PropTypes.bool,
    setOptionOne: PropTypes.func,
    setOptionTwo: PropTypes.func,
    styles: PropTypes.objectOf(PropTypes.string),
    onlyOneInputOption: PropTypes.bool,
    firstOptionReadOnly: PropTypes.bool
};

AddNewRow.defaultProps = {
    closeModal: noop,
    createAction: noop,
    dropdownOptions: [],
    isEdit: false,
    modalMessage: '',
    optionOneKey: '',
    optionOneValue: '',
    optionTwoKey: '',
    optionTwoValue: '',
    secondOptionDropdown: false,
    setOptionOne: noop,
    setOptionTwo: noop,
    styles: defaultStyles,
    onlyOneInputOption: false,
    firstOptionReadOnly: false
};

export default AddNewRow;
